export default function floatingButtons(app) {
    $(function(){
        $('#fixedActions').hover(function(){
            $(this).addClass('active')
        }, function(){
            $(this).removeClass('active')
        })
    })
}
